import { render } from "./GoogleAddressCustomer.vue?vue&type=template&id=1b328855&scoped=true&ts=true"
import script from "./GoogleAddressCustomer.vue?vue&type=script&lang=ts"
export * from "./GoogleAddressCustomer.vue?vue&type=script&lang=ts"

import "./GoogleAddressCustomer.vue?vue&type=style&index=0&id=1b328855&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b328855"]])

export default __exports__